import { useCallback } from "react";
import type { Person as FlightPerson } from "@b2bportal/air-booking-api";
import type { Person as CarPerson } from "@b2bportal/ground-api";
import type { Person as HotelPerson } from "@b2bportal/lodging-api";
import type { Name } from "@b2bportal/traveler-api";
import { useI18nContext } from "@hopper-b2b/i18n";

type Person = FlightPerson | HotelPerson | CarPerson;
// This is wip - there shall be a lot of ways to display a human name
// e.g. CLDR says these languages [1] displays surname first but it's not as easy as that
// https://github.com/unicode-org/cldr-json/blob/fb306a7267bef017efb843c356989ddcc892ae76/cldr-json/cldr-core/supplemental/personNamesDefaults.json#L8
// Like, in Japanese, John Doe is still displayed as John Doe in Katakana in many cases.
// Anyway, this simple function shall work for our purpose for now.
export const usePersonNameFormat = () => {
  const { language } = useI18nContext();
  return useCallback(
    (params: Pick<Person, "surname" | "givenName" | "middleName">) => {
      const { surname, givenName, middleName } = params;
      switch (language) {
        case "ja":
        case "ko":
          return format([surname, givenName, middleName]);
        default:
          return format([givenName, middleName, surname]);
      }
    },
    [language]
  );
};

export const useTravelerNameFormat = () => {
  const { language } = useI18nContext();
  return useCallback(
    (params: Name) => {
      const { first, middle, last } = params;
      switch (language) {
        case "ja":
        case "ko":
          return format([last, first, middle]);
        default:
          return format([first, middle, last]);
      }
    },
    [language]
  );
};

function format(array: string[]) {
  return array.filter((n) => n != null).join(" ");
}
